/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Input_SelectedInputs */

const en_file_input_selected = /** @type {(inputs: File_Input_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected`)
};

const de_file_input_selected = /** @type {(inputs: File_Input_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählt`)
};

/**
* | output |
* | --- |
* | "Selected" |
*
* @param {File_Input_SelectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const file_input_selected = /** @type {((inputs?: File_Input_SelectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Input_SelectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_file_input_selected(inputs)
	return en_file_input_selected(inputs)
});